import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalDataSource } from 'angular2-smart-table';
import { EventService, IEventStand } from '../../services/database/event/event.service';
import { EventBartenderService, IEventBartender } from '../../services/database/event/eventbartender.service';
import { UserService } from '../../services/database/user/user.service';
import { IUser } from '../../services/model/user.model';
import { SearchService } from '../../services/search/search.service';
import { ToastrService } from '../../services/toastr/toastr.service';

@Component({
  selector: 'ngx-bartenders',
  templateUrl: './bartenders.component.html',
  styleUrls: ['./bartenders.component.scss']
})
export class BartendersComponent implements OnInit {

  bartenders: IEventBartender[];
  source: LocalDataSource = new LocalDataSource();
  searchValue: string;
  users: any[];
  userKey: string;
  eventId: string;

  settings = {
    actions: {
      add: false,
      edit: true,
      delete: true,
      position: 'right'
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark-circle"></i>',
      cancelButtonContent: '<i class="nb-close-circled"></i>',
      confirmSave: true
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    }
  };
  mySettings = {
    actions: {
      add: false,
      edit: true,
      delete: true,
      position: 'right'
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark-circle"></i>',
      cancelButtonContent: '<i class="nb-close-circled"></i>',
      confirmSave: true
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      key: {
        title: 'ID',
        show: false,
        editable: false
      },
      firstName: {
        title: 'First Name',
        type: 'string',
        editable: false
      },
      lastName: {
        title: 'Last Name',
        type: 'string',
        editable: false
      },
      eventStandId: {
        title: 'Event stand ID',
        type: 'string',
        editable: true,
        editor: {
          type: 'list',
          config: {
            list: []
          }
        }
      },
      eventStandName: {
        title: 'Event stand',
        type: 'string',
        editable: false
      }
    },
  };

  constructor(
    private bartenderService: EventBartenderService,
    private eventService: EventService,
    private userService: UserService,
    private searchService: SearchService,
    private toastrService: ToastrService,
    private route: ActivatedRoute
    ) {
  }

  ngOnInit(): void {
    this.eventId = this.route.snapshot.paramMap.get('eventId')
    this.bartenderService.getBartenders(this.eventId).subscribe((bartenders) => {
      const data = [];
      bartenders.forEach(bartender => {
        data.push({
          firstName: bartender.user? bartender.user.firstName : '',
          lastName: bartender.user? bartender.user.lastName : '',
          userId: bartender.user_id,
          key: bartender.key,
          eventStandId: bartender.eventstand_id,
          eventStandName: bartender.eventstand? bartender.eventstand.name : ''
        })
      })
      this.eventService.getEventStands(this.eventId).subscribe((stands) => {
        const values = [{value: 'null', title: ''}];
        stands.forEach((stand: IEventStand) => {
          values.push({
            value: stand.key,
            title: stand.name
          })
        })
        this.mySettings.columns.eventStandId.editor.config.list = values;
        this.settings = Object.assign({}, this.mySettings)
        this.source.load(data);
      })
    })
  }

  eventStandRenderer(value: string) {
    return value;
  }

  onDeleteConfirm(event): void {
    if (window.confirm('Are you sure you want to delete this bartender?')) {
      this.bartenderService.deleteBartender(event.data.key).then((succes) => {
          this.userKey = null;
          this.searchValue = null;
          this.toastrService.show('Success', 'Successfully deleted bartender', 'success');
          event.confirm.resolve();
        })
        .catch((error) => {
          this.userKey = null;
          this.searchValue = null;
          this.toastrService.show('Error', error, 'danger')
        })
    } else {
      event.confirm.reject();
    }
  }

  onEditConfirm(event) {
    let eventStandId = event.newData.eventStandId == 'null' ? null : event.newData.eventStandId;
    this.bartenderService.updateBartender(event.newData.key, eventStandId).then(() => {
      event.confirm.resolve();
    })
  }

  search() {
    const searchValue = this.searchValue;
    if(searchValue === '') {
      this.users = [];
    }
    else if (searchValue && searchValue.length > 1) {
        setTimeout(() => {
          this.searchService.searchUser(searchValue, this.eventId).then((eventusers) => {
            this.users = eventusers.hits;
          })
    })
    }
    else {
      this.users = [];
    }
  }

  clickItem(user:any) {
    this.searchValue = user.firstName + " " + user.lastName;
    this.userKey = user.objectID;
  }

  addUser() {
    if(!this.searchValue || !this.userKey)
    {
      return;
    }
    this.bartenderService.addBartender({
      user_id: this.userKey,
      event_id: this.eventId
    }).then((succes) => {
      this.searchValue = '';
      this.userKey = null;
      this.toastrService.show('Success', 'Successfully added bartender', 'success')
    })
    .catch((error) => {
      this.toastrService.show('Error', error, 'danger')
    })
  }

}
